import * as React from 'react';
import {FunctionComponent} from 'react';
import {MapConfig} from "./MapConfig";
import {StyledProps} from "../StyledProps";
import {GoogleMap, useLoadScript} from "@react-google-maps/api";
import {GOOGLE_MAP_API_KEY} from "../../Config";
import Loading from "../loading/Loading";
import HeatMap from "./heatmap/HeatMap";


interface MapProps {
    config: MapConfig
}

const Map: FunctionComponent<MapProps & StyledProps> = (
    {
        config,
        className,
        children
    }
) => {

    const { isLoaded, loadError } = useLoadScript({
        googleMapsApiKey: GOOGLE_MAP_API_KEY,
        language: 'es',
        libraries: ["visualization"]
    });

    const {center, zoom} = config.position;
    const {mapOptions, containerStyle} = config;

    if (!isLoaded && !loadError) {
        return <Loading loading={true}/> ;
    } else if (isLoaded && loadError) {
        alert(loadError.message);
    }

    return (
        <GoogleMap
            mapContainerStyle={containerStyle}
            center={new google.maps.LatLng(center.lat, center.lng)}
            zoom={zoom}
            options={mapOptions}
        >
            {children}
            <HeatMap/>
        </GoogleMap>
    )
};

export default Map;
